export const COMPONENT_NAME = 'viewport';
export const FS_CHANGED_EVENT = 'fullscreen_changed';
export const SA_CHANGED_EVENT = 'safe_area_changed';
export const CSA_CHANGED_EVENT = 'content_safe_area_changed';
export const VIEWPORT_CHANGED_EVENT = 'viewport_changed';